import { ClipLoader } from "react-spinners"
import { Button } from "./button"

const LoadingBtn = ({ loading, children, ...props }) => {  
    return (
        <Button {...props}>
            {loading ? <ClipLoader /> : children}
        </Button>
    )
}
export default LoadingBtn